export default __webpack_public_path__ + "static/media/maths.c0e0e598.svg";